// extracted by mini-css-extract-plugin
module.exports = {"diagnose":"MobileDiagnose_diagnose__CKzMh","header":"MobileDiagnose_header__AdlhT","radioButton":"MobileDiagnose_radioButton__2XteT"};